module.exports = __webpack_public_path__ + "38670817e2c75f0650479b7bb34e4dbf.svg";